<template>
  <vf-breadcrumbs
    v-if="product"
    :class="[brandClasses.breadcrumbs, { '!hidden': hideBreadcrumbs }]"
    :items="product.breadcrumbs || []"
    :last-step="showBreadcrumbsLastStep ? { label: product.name } : undefined"
    :max-items="breadcrumbsMaxItems"
  />
</template>

<script setup lang="ts">
const { brandClasses, breadcrumbsMaxItems, hideBreadcrumbs, showBreadcrumbsLastStep } = useAppConfig().pages.pdp
const { product } = usePdp()
</script>
